<cc-progress-bar [isLoading]="isLoading$ | async"></cc-progress-bar>
<!-- !TODO: update to v18 -->
@if (data$ | async; as data) {
  <div class="flex flex-col h-full space-y-2">
    <cc-line-chart [data]="data" class="w-full"></cc-line-chart>
    <!-- [options]="jsChartOptions$ | async" -->
  </div>
}
